import React from 'react';
import styled from 'styled-components';
import googlePlayBadge from '../../assets/badges/google-play-badge.png';

// Google Play is live. The Apple side stays a plain "Coming soon" tile, not
// Apple's official badge: Apple's guidelines present that badge as "available
// now". Swap in the official badge once the iPhone app is approved and live.
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=au.com.desifirms.app';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${(p) => (p.$center ? 'center' : 'flex-start')};
  gap: 12px;
`;

const PlayLink = styled.a`
  display: inline-block;
  transition: transform 0.15s ease;
  &:hover { transform: scale(1.04); }
  img { height: ${(p) => p.$height}px; width: auto; display: block; }
`;

const SoonTile = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: ${(p) => p.$height}px;
  padding: 0 16px;
  border: 1.5px solid ${(p) => (p.$dark ? 'rgba(255,255,255,0.35)' : '#d1d5db')};
  border-radius: 10px;
  color: ${(p) => (p.$dark ? 'rgba(255,255,255,0.7)' : '#6b7280')};
  cursor: default;
  svg { width: 22px; height: 22px; flex-shrink: 0; }
  span { display: block; line-height: 1.15; text-align: left; }
  .small { font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }
  .big { font-size: 15px; font-weight: 700; }
`;

const AppleGlyph = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.572-2.27 1.206-2.98.744-.85 2.037-1.52 3.107-1.55.03.1.03.2.03.3zm4.607 16.44c-.28.62-.4 1.02-.75 1.65-.5.9-1.19 2.03-2.05 2.04-.77.01-.97-.5-2.01-.5-1.04 0-1.28.49-2.04.51-.86.03-1.5-.98-2-1.87-1.4-2.5-1.65-5.44-.73-7.15.65-1.2 1.83-1.96 3.1-1.98.79-.02 1.53.53 2.01.53.48 0 1.39-.66 2.34-.56.4.02 1.5.16 2.22 1.2-.06.04-1.32.77-1.31 2.3.02 1.83 1.6 2.44 1.62 2.45.02.04-.32 1.4-.42 1.72z" />
  </svg>
);

/** Store badges for the Desi Firms app. `dark` for use on a dark footer. */
export default function AppStoreBadges({ center = false, dark = false, height = 44 }) {
  return (
    <Row $center={center}>
      <PlayLink href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" $height={height}>
        <img src={googlePlayBadge} alt="Get it on Google Play" />
      </PlayLink>
      <SoonTile $dark={dark} $height={height} title="Coming soon on the App Store (iPhone and iPad)">
        <AppleGlyph />
        <span>
          <span className="small">Coming soon on the</span>
          <span className="big">App Store</span>
        </span>
      </SoonTile>
    </Row>
  );
}
